import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { PaymentMethod } from '../../../../shared/store/BaseColonistStoreProduct.ts';
export function applyOwnedMembershipToViews(membershipViews, ownedMembership, paymentMethod) {
    if (ownedMembership == undefined) return;
    let makeUpgrade = false;
    const disableMembershipManagement = shouldDisableMembershipManagement(paymentMethod);
    const iOwnAnnualMembership = ColonistMembershipProduct.isAnnualMembership(ownedMembership.type);
    for (const membershipView of membershipViews){
        if (disableMembershipManagement) {
            if (membershipView.membershipProduct.type == ownedMembership.type) {
                const isGift = paymentMethod == PaymentMethod.None;
                if (isGift) {
                    membershipView.changeToCancelButton();
                } else {
                    membershipView.changeToOwnedButton();
                }
                continue;
            }
            membershipView.removeButton();
            continue;
        }
        if (!iOwnAnnualMembership && ColonistMembershipProduct.isAnnualMembership(membershipView.membershipProduct.type)) {
            membershipView.changeToGoAnnualButton();
            continue;
        }
        if (makeUpgrade) {
            membershipView.changeToUpgradeButton();
            continue;
        }
        if (membershipView.membershipProduct.type == ownedMembership.type) {
            membershipView.changeToManageButton();
            makeUpgrade = true;
            continue;
        }
        membershipView.changeToDowngradeButton();
    }
}
function shouldDisableMembershipManagement(paymentMethod) {
    const isStripe = paymentMethod == PaymentMethod.Stripe;
    const isIAP = paymentMethod == PaymentMethod.Apple || paymentMethod == PaymentMethod.Android;
    const disableMembershipManagement = !isStripe && !isIAP;
    return disableMembershipManagement;
}
